<script lang="ts">
    import Gutter from '$components/layout/gutter.svelte';
    import Text from '$components/common/text/text.svelte';
    import { theme } from '$theme/theme.svelte';

    export let color: 'light' | 'dark' = 'dark';
    export let title: string;
    export let subtitle: string | undefined = undefined;
    export let marginBottom = $theme.spacing[26];
    export let maxWidth = $theme.breakpoints.md;
</script>

<header
    class="header"
    style="{`margin-bottom:${marginBottom}; max-width:${maxWidth};`}}"
    {...$$restProps}
>
    <Gutter>
        <Text
            bold
            center
            variant={$theme.smUp ? 'displayMedium' : 'headlineMedium'}
            class="title"
            color={color === 'light' ? $theme.colors.white : $theme.colors.primary[900]}
            max-width={maxWidth}
        >
            {@html title}
        </Text>
        <Text
            center
            variant={$theme.smUp ? 'bodyXLarge' : 'bodyLarge'}
            class="subtitle"
            color={color === 'light' ? $theme.colors.white : $theme.colors.common.light.medium}
        >
            {@html subtitle}
        </Text>
    </Gutter>
</header>

<style>
    .header {
        margin-left: auto;
        margin-right: auto;
    }

    .header :global(.title) {
        margin-right: auto;
        margin-left: auto;
        margin-bottom: var(--spacing-12);
    }

    .header :global(.subtitle) {
        max-width: 1127px;
        margin: 0 auto;
    }
</style>
